import { Image } from 'react-native'
import images from '../../Images'

const Images = {
  mobileDark: Image.resolveAssetSource(
    require('../../../Images/Icons/icMobileWhite.png')
  ),
  routerDark: Image.resolveAssetSource(
    require('../../../Images/Icons/icRouterWhite.png')
  ),
  parentalControlDark: Image.resolveAssetSource(
    require('../../../Images/Icons/icParentalControlRed.png')
  ),
  icInfoRed: Image.resolveAssetSource(
    require('../../../Images/Icons/icInfoCircleRed.png')
  ),
  roaming: images.roaming_white,
  tv: images.tv_white,
  mobile: images.mobile_white,
  wifi: images.wifi_white,
  router: images.router_white,
}

export { Images } // eslint-disable-line import/prefer-default-export
